import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { RootState } from '../../app/store';
import { AddWarning, fetchWarningList } from '../../services/warningAPI';

const initialState: any = {
  timer: {}, 
  timerAck: {},
  openDrawerState: {},
  list: {
    data: null,
    status: 'idle'
  } ,
  ackList: {
    data: null,
    status: 'idle'
  } 
};

export const getWarningListAsync = createAsyncThunk(
  'warning/list',
  async ({ctx,startDate,stopDate,
    taskId, jobId, alsoPilots,  username 
  }
    :{ctx: string, 
      startDate?: string,
      stopDate?: string,
      taskId?: string,
      jobId?: string,
      alsoPilots?: string,
      username?: string }) => {
    try {
      const response: any = await fetchWarningList( {ctx: ctx ,
        startDate: startDate, stopDate: stopDate,
        taskId: taskId, jobId:jobId, alsoPilots:alsoPilots, username: username }
      );
      //console.log('getWarningListAsync', response);
      return response.data;
    } catch (e: any) {
      return Promise.reject(e.data ? e.data : e);
    }
  }
);

export const getWarningAckListAsync = createAsyncThunk(
  'warning/acklist',
  async ({ctx }
    :{ctx: string }) => {
    try {
      const response: any = await fetchWarningList(  {ctx: ctx ,
        cleaned:false}
      );
      return response.data;
    } catch (e: any) {
      return Promise.reject(e.data ? e.data : e);
    }
  }
);




export const addWarningAsync = createAsyncThunk(
  'mapTools/addWarning',
  async (body : any) => {
    try {
      const response: any = await AddWarning( body );
      return response.data;
    } catch (e: any) {
      return Promise.reject(e.data ? e.data : e);
    }
  }
);


export const warningSlice = createSlice({
  name: 'warning',
  initialState,
  reducers: {
    setWarningAcknTimer: (state,  action) => {
      state.timerAck = action.payload;
    },
    setWarningTimer: (state,  action) => {
      state.timer = action.payload;
    } ,
    openWarning: (state, action ) => {
      state.openDrawerState = action.payload;
    }
  },
  extraReducers: (builder) => {
    builder
      .addCase(getWarningListAsync.pending, (state) => {
        state.list.status = 'loading';
      })
      .addCase(getWarningListAsync.fulfilled, (state, action) => {
        state.list.status = 'success';
        state.list.data = action.payload;
      })
      .addCase(getWarningListAsync.rejected, (state: any, action) => {
        state.list.status = 'failed'; 
      })
      .addCase(getWarningAckListAsync.pending, (state) => {
        state.ackList.status = 'loading';
      })
      .addCase(getWarningAckListAsync.fulfilled, (state, action) => {
        state.ackList.status = 'success';
        state.ackList.data = action.payload;
      })
      .addCase(getWarningAckListAsync.rejected, (state: any, action) => {
        state.ackList.status = 'failed'; 
      });


  }
});

export const {
  setWarningTimer,
  setWarningAcknTimer,
  openWarning
} = warningSlice.actions;
export const warningListState = (state: RootState) =>
  state.warning.list; 
export const warningAckListState = (state: RootState) =>
  state.warning.ackList; 
export const warningTimerState = (state: RootState) => state.warning.timer;
export const warningAckTimerState = (state: RootState) => state.warning.timerAck;
export const warningOpenState = (state: RootState) => state.warning.openDrawerState;
export default warningSlice.reducer;
